
export const CONVERSATION_CREATE_SUCCESS = 'CONVERSATION_CREATE_SUCCESS';
export const CONVERSATION_CREATE_REQUEST = 'CONVERSATION_CREATE_REQUEST';
export const CONVERSATION_CREATE_ERROR = 'CONVERSATION_CREATE_ERROR';
